import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * DateAdapter custom que parseia datas no formato brasileiro `DD/MM/YYYY`.
 *
 * O NativeDateAdapter padrão do Angular Material ignora `MAT_DATE_FORMATS.parse.dateInput`
 * e cai em `Date.parse(value)`, que no Chrome interpreta `30/05/2027` como `MM/DD/YYYY`
 * → mês 30 inválido → `Invalid Date`. Isso fazia inputs com matDatepicker marcarem
 * o erro `matDatepickerParse` ao digitar.
 *
 * Esta classe sobrescreve apenas o `parse()`: se o valor casa com `DD/MM/YYYY`,
 * monta o Date manualmente (sem timezone, no horário local). Para qualquer outro
 * formato, delega ao comportamento padrão.
 */
@Injectable()
export class PtBrDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      const match = value.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (match) {
        const day = +match[1];
        const month = +match[2] - 1;
        const year = +match[3];
        const d = new Date(year, month, day);
        const isValid =
          d.getFullYear() === year &&
          d.getMonth() === month &&
          d.getDate() === day;
        return isValid ? d : null;
      }
    }
    return super.parse(value);
  }
}
